
<template>
    <div>
        <Gh-Dialog ref="gh_dialog" size="big" :title="title" @dialogBack="uploadFile">
            <template v-slot:content>
                <div class="import_box">
                    <div class="step_box">
                        <div class="step_item active">
                            <span class="c">1</span>
                            <span class="title">下载模板</span>
                        </div>
                        <div class="line"></div>
                        <div class="step_item">
                            <span class="c">2</span>
                            <span class="title">上传文件</span>
                        </div>
                        <div class="line"></div>
                        <div class="step_item">
                            <span class="c">3</span>
                            <span class="title">导入完成</span>
                        </div>
                    </div>
                    <div class="act_step">
                        <div class="step_1">
                            <p>1、请按照模板格式准备需要导入的数据</p>
                            <div class="down_temp" @click="downloadFile">
                                <i class="el-icon-download"></i>
                                <span>{{`下载批量创建${name}导入模板`}}</span>
                            </div>
                        </div>
                        <div class="step_2">
                            <p>2、请选择需要导入的文件</p>
                            <div class="upload_file">
                                <el-upload
                                    class="upload-btn"
                                    ref="uploadFile"
                                    :action="uploadUrl"
                                    :headers="{'Authorization': 'Bearer ' + ($store.state.token)}"
                                    :file-list="importFile"
                                    :show-file-list="false"
                                    :on-change="uploadChange"
                                    :limit="2"
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                                    :auto-upload="false">
                                    <div class="button">
                                        <i class="el-icon-upload2"></i>
                                        <span>上传</span>
                                    </div>&nbsp;&nbsp;
                                    <span slot="tip" class="el-upload__tip">{{ importTip || '支持 xlsx文件，单个文件不得大于10M，最多不超过1000行' }}</span>
                                </el-upload>
                            </div>
                            <p class="importFileName" v-if="importFile.length > 0">
                                <span>{{importFile[0] ? importFile[0].name : ''}}</span>
                                <i class="el-icon-close" @click="delImportFile"></i>
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:confirm_btn>
                <div class="button confirm" :class="(importFile && importFile.length > 0) ? 'info_update' : 'not_act'" @click="uploadFile">
                    <span v-show="!lodding">确定</span>
                    <span v-show="lodding">上传中...</span>
                </div>
            </template>
        </Gh-Dialog>
    </div>
</template>
<script>
    export default{
        name: 'import',
        data() {
            return {
                importFile: [],
                lodding: false
            }
        },
        props: ['name','title', 'importTip', 'uploadUrl', 'downloadUrl'],
        watch: {
        },
        created() {
            
        },
        methods: {
            openDialog() {
                this.$refs.gh_dialog.show = true;
            },
            uploadChange(file, fileList) {
                this.lodding = false;
                if(file.response) {
                    if(file.response.code != 200) {
                        if(file.response.code == 1012) {
                            this.$message.error('用户暂无此权限');
                            return;   
                        }
                        this.$message.error(file.response.msg || file.response.message);
                        if(file.response.data.fileUrl) {
                            let downloadA = document.createElement('a');
                            downloadA.download = '导入失败详情.xlsx';
                            downloadA.href = file.response.data.fileUrl;
                            document.body.appendChild(downloadA);
                            downloadA.click();
                            document.body.removeChild(downloadA);
                        }
                        this.lodding = false;
                        this.importFile = [];
                        this.$refs.uploadFile.clearFiles();
                    }else{
                        this.$message.success('导入成功！');
                        this.$refs.gh_dialog.show = false;
                        this.importFile = [];
                        this.$refs.uploadFile.clearFiles();
                        this.$emit('uploadChange', file, fileList);
                    }
                }else{
                    this.importFile = fileList.slice(-1);
                    if(this.importFile[0].size/1024/1024 > 10) {
                        this.$message.warning('总大小不得超过10M！');
                        return false;
                    }
                }
                
            },
            downloadFile() {
                this.api[this.downloadUrl]({}).then(data => {})
            },
            uploadFile() {
                if(this.importFile && this.importFile.length > 0 && !this.lodding) {
                    this.lodding = true;
                    this.$refs.uploadFile.submit();
                }
            },
            delImportFile() {
                this.$refs.uploadFile.abort(this.importFile[0]);
                this.importFile = [];
                this.$refs.uploadFile.uploadFiles.splice(0, 1);
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/dialog/import-file.vue